import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import { StatusCartFilterRequest } from '@/main/models/request';

export abstract class IQuoteSupplierItemStatus {
  abstract getDomain(request: StatusCartFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}

